export default __webpack_public_path__ + "static/media/404.14ce892e.jpg";